import React from 'react';
import { RefreshCw, Download } from 'lucide-react';
import './HeaderUtilities.css';

/* Utilidades universales del encabezado (F4.4, principio rector §0):
   Actualizar → Exportar, en ese orden, SIEMPRE juntas al extremo derecho de
   la fila del título — en TODAS las tabs de TODOS los módulos. Diseño propio
   (par compacto ícono+texto en una sola cápsula) para distinguirlas a simple
   vista de las acciones de negocio (Button primario/secundario).
   `exportMenu`: nodo opcional (dropdown) anclado a la cápsula — para módulos
   cuyo Exportar despliega opciones (Inventario). */
export default function HeaderUtilities({
  onRefresh,
  refreshing = false,
  onExport = null,          // sin onExport no se pinta el botón (ej. rol sin permiso)
  exportDisabled = false,
  exportMenu = null,
}) {
  return (
    <div className="ui-utilities" role="group" aria-label="Actualizar y exportar">
      <button
        type="button"
        className="ui-utility"
        onClick={onRefresh}
        disabled={refreshing}
        title="Volver a cargar los datos de esta pestaña"
      >
        <RefreshCw size={13} className={refreshing ? 'ui-utility-spin' : undefined} aria-hidden="true" />
        <span>Actualizar</span>
      </button>
      {onExport && (
        <>
          <span className="ui-utility-sep" aria-hidden="true" />
          <button
            type="button"
            className="ui-utility"
            onClick={onExport}
            disabled={exportDisabled}
            title="Exportar el listado de esta pestaña a Excel"
          >
            <Download size={13} aria-hidden="true" />
            <span>Exportar</span>
          </button>
          {exportMenu}
        </>
      )}
    </div>
  );
}
